// extracted by mini-css-extract-plugin
export default {"root":"TextWithLinkSection_root__PRo0I","link":"TextWithLinkSection_link__DRBxm","text":"TextWithLinkSection_text__y-d6u"};